
import type { PropType } from 'vue'
import type { EpbSelectOption } from '../shared/epb-select'
import { defineComponent, ref, watch } from 'vue'
import { useX } from '../../composables/x/use-x'
import { EpbSelect } from '../shared/epb-select'

export default defineComponent({
  components: {
    EpbSelect,
  },
  props: {
    queries: {
      type: Array as PropType<Array<EpbSelectOption>>,
      required: true,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    placeholder: {
      type: String as PropType<string>,
      required: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const x = useX()

    const baseClass = 'x-query-select'

    const selectedQuery = ref<string>('')

    function selectQuery(query: string): void {
      selectedQuery.value = query
      x.setQuery(selectedQuery.value)
      emit('selectedQuery', query)
    }

    function resetQuery(): void {
      selectedQuery.value = ''
      x.clearQuery()
      emit('selectedQuery', undefined)
    }

    watch(() => props.queries, onQueriesChange, { immediate: true, deep: true })

    function onQueriesChange(): void {
      if (props.queries.length) {
        if (isSelectedQueryInvalid()) {
          selectFirstQuery()
        }
      } else {
        resetQuery()
      }
    }

    function isSelectedQueryInvalid(): boolean {
      return !props.queries.some(query => query.value === selectedQuery.value)
    }

    function selectFirstQuery(): void {
      selectQuery(props.queries[0].value)
    }

    return {
      MIN_QUERIES_TO_BE_ENABLED: 2,
      baseClass,
      selectedQuery,
      selectQuery,
    }
  },
})
